/* eslint-disable react/prop-types */
import React from 'react';
import { Spin, Tooltip } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { formatChatSessionDate } from '../../services/aiInsightsApi';

/**
 * Ask Evans chat history sidebar — Lessons Learned sister.
 * Chats / Your Ask Evans sessions + New Chat Session + history rows.
 */
const SpacerLogAiChatSidebar = ({
  sessions = [],
  activeId = null,
  loading = false,
  onNewChat,
  onSelect,
  onDelete,
  compact = false,
}) => (
  <aside
    className={`spacer-ask-evans__sidebar${compact ? ' spacer-ask-evans__sidebar--compact' : ''}`}
    aria-label="Chat history"
  >
    <div className="spacer-ask-evans__sidebar-head">
      <h2 className="spacer-ask-evans__sidebar-title">Chats</h2>
      <p className="spacer-ask-evans__sidebar-sub">Your Ask Evans sessions</p>
    </div>

    <div className="spacer-ask-evans__sidebar-body">
      <button type="button" className="spacer-ask-evans__sidebar-new" onClick={onNewChat}>
        <PlusOutlined />
        <span>New Chat Session</span>
      </button>

      <div className="spacer-ask-evans__sidebar-label">Chat History</div>

      <div className="spacer-ask-evans__sidebar-list">
        {loading ? (
          <div className="spacer-ask-evans__sidebar-empty">
            <Spin size="small" />
          </div>
        ) : null}

        {!loading && !sessions.length ? (
          <div className="spacer-ask-evans__sidebar-empty">No previous sessions.</div>
        ) : null}

        {!loading
          ? sessions.map((s) => {
              const active = String(s.id) === String(activeId);
              const when = formatChatSessionDate(
                s.lastActive || s.updatedAt || s.createdAt
              );
              return (
                <div
                  key={s.id}
                  className={`spacer-ask-evans__sidebar-item${
                    active ? ' spacer-ask-evans__sidebar-item--active' : ''
                  }`}
                >
                  <button
                    type="button"
                    className="spacer-ask-evans__sidebar-item-main"
                    onClick={() => onSelect?.(s.id)}
                    title={s.title}
                  >
                    <span className="spacer-ask-evans__sidebar-item-title">
                      {s.title || 'Untitled chat'}
                    </span>
                    {when ? (
                      <span className="spacer-ask-evans__sidebar-item-meta">{when}</span>
                    ) : null}
                  </button>
                  {onDelete ? (
                    <Tooltip title="Delete session">
                      <button
                        type="button"
                        className="spacer-ask-evans__sidebar-item-del"
                        aria-label="Delete session"
                        onClick={(e) => {
                          e.stopPropagation();
                          onDelete(s.id);
                        }}
                      >
                        <DeleteOutlined />
                      </button>
                    </Tooltip>
                  ) : null}
                </div>
              );
            })
          : null}
      </div>
    </div>
  </aside>
);

export default SpacerLogAiChatSidebar;
